import { gql } from "apollo-boost";

export const LISTING_AGENT_MATCHES = gql`
  query ListingAgentMatches($propertyId: ID!) {
    listing_agent_matches(input: { property_id: $propertyId }) {
      brokerage
      brokerage_address
      contact_id
      has_sold_in_building
      homes_sold_nearby
      homes_sold_recent
      homes_sold_similar
      is_pro
      license_type
      median_sales_price
      name
      photo_url
      profile_url
      years_experience
      uuid
    }
  }
`;
